import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingComponent from "../components/LoadingComponent";
import { loadingSet, login } from "../store/actions/userActions";
import Swal from "sweetalert2";

export default function LoginPage() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { loading } = useSelector((state) => state.users);
	const [loginInput, setLoginInput] = useState({
		email: "",
		password: "",
	}); //dalam react, perubahan state harus immutable

	const changeInputLogin = (e) => {
		const { name, value } = e.target;
		setLoginInput({ ...loginInput, [name]: value }); //<<< menggunakan setter, dan memberikan object baru
		//contoh salah seperti dibawah
		//loginInput[name] = value
		//setLoginInput(loginInput)
	};

	const submitHandler = (e) => {
		e.preventDefault();
		dispatch(login(loginInput))
			.then((data) => {
				localStorage.setItem("access_token", data.access_token);
				localStorage.setItem("username", data.username);

				navigate("/");
			})
			.catch((err) => {
				Swal.fire({
					icon: "error",
					title: "Error",
					text: err,
				});
			})
			.finally(() => {
				dispatch(loadingSet(false));
			});
	};

	return (
		// react fragment, dalam react semua isinya hanya boleh dibungkus 1 tag, jika dibutuhkan lebih dari 1 dan tidak ingin merusak struktur, gunakan react fragment, yg dibawah ini shorthand nya
		<>
			{loading ? (
				<LoadingComponent />
			) : (
				<div className="container pt-5">
					<div className="row justify-content-center">
						<div className="col-md-7 col-lg-5 col-sm-7">
							<div className="p-4 p-md-5 border">
								<h1 className="text-center mb-3">News Portal</h1>
								<form onSubmit={submitHandler}>
									<div className="mb-3">
										<label className="form-label">Email Address</label>
										<input
											type="text"
											name="email"
											className="form-control"
											value={loginInput.email}
											onChange={changeInputLogin}
										/>
									</div>
									<div className="mb-3">
										<label className="form-label">Password</label>
										<input
											type="password"
											name="password"
											className="form-control"
											value={loginInput.password}
											onChange={changeInputLogin}
										/>
									</div>
									<div>
										<button type="submit" className="btn btn-primary form-control">
											Sign in
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
}
